import axiosRequest from './restapi';

export const checkSignUpEmail = (email: string) => {
  return axiosRequest({
    method: 'get',
    url: `users/check-email/${email}`,
  });
};

export const signUpFormSubmit = (userRole: string, data: any) => {
  return axiosRequest({
    method: 'post',
    url: `${userRole.toLowerCase()}s/register`,
    data,
  });
};
